import i18next from "../../../../../i18n";

i18next.addResourceBundle("en", "DropdownItem", {
    search: "Search",
});

i18next.addResourceBundle("fr", "DropdownItem", {
    search: "Rechercher",
});
